export default "__VITE_ASSET__6a07cac5__"